import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a pendant lamp hanging from the 2.6 m ceiling: a small ceiling
// rose, a thin cord and a cone shade with a glow-tone bulb disc beneath.
const BLACK = "#2e2e30";
const GLOW = "#f5e9c8";

const CEILING = 2.6;
const SHADE_TOP = 2.14;
const SHADE_H = 0.2;

export const ceilingLamp = defineModel({
  id: "ceiling-lamp",
  batchId: "modern",
  name: "Ceiling lamp",
  tags: ["modern", "interior", "fixture", "lighting", "ceiling"],
  summary: "A matte-black pendant lamp hanging from the ceiling on a thin cord.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // Ceiling rose.
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.035, 12), color: BLACK,
        position: [0, CEILING - 0.0175, 0] },
      // Thin cord down to the shade.
      { geometry: new THREE.CylinderGeometry(0.008, 0.008, CEILING - SHADE_TOP, 6), color: BLACK,
        position: [0, (CEILING + SHADE_TOP) / 2, 0] },
      // Cone shade opening downward.
      { geometry: new THREE.CylinderGeometry(0.045, 0.19, SHADE_H, 14), color: BLACK,
        position: [0, SHADE_TOP - SHADE_H / 2, 0] },
      // Glow-tone bulb disc hanging clearly beneath the shade rim.
      { geometry: new THREE.CylinderGeometry(0.075, 0.075, 0.1, 12), color: GLOW,
        position: [0, SHADE_TOP - SHADE_H - 0.045, 0] },
    ];
  },
  animations: [],
});
